export const REQUEST_PASS_STATUS = {
	NEW: 1, // Nouveau
	ON_GOING: 2, // En cours
	WAITING_CLIENT: 3, // En attente CLIENT
	WAITING_INTERN: 4, // En attente INTERNE
	BLOCKED: 5, // Bloqué
	VALIDATED: 6, // Validé
	SENT: 7, // Devis émis
	SIGNED: 8, // Devis signé
	ACCEPTED: 9, // Accord de principe émis
	BILLED: 10, // Facturé
	TERMINATED: 11, // Terminé
	REFUSED: 12, // Refusé
	CANCELLED: 13, // Refusé
};
export const REQUEST_PASS_TYPE = {SUPERIEUR: "superieur", AUTOROUTE: "autoroute",};
export const PROFIL = {ADMINISTRATEUR: 1, GESTIONNAIRE: 2, INTERVENANT: 3, CONSULTANT: 4, NOUVEAU: 6, CLIENT: 5,};
export const CIRCULATION_SPEED_TYPE = {SUP_TO_50: '0', INF_TO_50: '1',};
export const IDENTITY_AGENT_TYPE = {POUR_SON_COMPTE: "0", POUR_AUTRUI: "1"};
export const TRJT_TYPE = {ALLER_SIMPLE: "0", ALLER_RETOUR: "1"};
export const CLIENT_TYPE = {MANDATAIRE: "0", TRANSPORTEUR: "1", TIER: "2"};
export const FACTURATION_TYPE = {DEVIS: "devis", FACTURE: "facture"}
export const PLANIFICATION_STATUS = {
	NEW: "NEW",
	AVAILABLE: "AVAILABLE",
	ACCEPTED_CENTER: "ACCEPTED_CENTER",
	ACCEPTED_PROVISIONAL: "ACCEPTED_PROVISIONAL",
	CONFIRMED_CLIENT: "CONFIRMED_CLIENT",
	CONFIRMED_CENTERS: "CONFIRMED_CENTERS",
	AGREEMENT_ISSUED: "AGREEMENT_ISSUED",
	PASSAGE_MADE: "PASSAGE_MADE",
	NOT_DONE: "NOT_DONE",
	CANCELLED: "CANCELLED",
	REFUSED:"REFUSED",

	UNAVAILABLE:"UNAVAILABLE",
	AWAITING_VALIDATION:"AWAITING_VALIDATION",
	DELAYED:"DELAYED",
	POSTPONED:"POSTPONED",
	VALIDATED:"VALIDATED",
}
export const DOCUMENT_TYPE = {
	DOCUMENT: "DOCUMENT",
	DOCUMENT_ADMIN: "DOCUMENT_ADMIN",
	CONTRACT: "CONTRACT",
	SAP: "SAP",
	DEVIS: "DEVIS",
	FACTURE: "FACTURE",
}
export const REGEX_PR = '^[0-9]{1,3}(\\.[0-9]{0,4}){0,1}$';
export const CHANNEL_TYPE = {INTERNE: "interne", EXTERNE: "externe", MESSAGE: "message"};

export const PARAMETER = {
    LEGAL_NOTICE: "LEGAL_NOTICE",
	PARTICULAR_NOTICE: "PARTICULAR_NOTICE",
    ALERT_CHANGE: "ALERT_CHANGE",
    COUT_UNITAIRE: "COUT_UNITAIRE",
    COUT_KM_PA: "COUT_KM_PA",
    COST: "COST",
	NAT_CONVOI: "NAT_CONVOI",
	COST_CENTER: "COST_CENTER",
	CODE_LOCALISATION: "CODE_LOC",
	DEFAULT_WWLOC: "DEFAULT_WWLOC",
	WWACV: "WWACV",
}

export const PARAMETER_VALUE = {
	ALERT_CHANGE: {
		ENGAGE: "Engagement",
		DEVIS_VALIDATED: "Validation du devis",
		DOCUMENT_UPLOADED: "Import de document",
		PLANNING_FILLED: "Saisie de créneaux de planification",
	}
}
